import { CalendarCheck } from 'lucide-react';
import type { LucideProps } from 'lucide-react';

export default function AppLogoIcon(props: LucideProps) {
    return <CalendarCheck {...props} strokeWidth={2.5} />;
}
